export default {
  data () {
    return {
      loadedData: false,
      list: [],
      currentPage: 1,
      pageSize: 10,
      totalRow: 0,
      pageSizeList: [10, 20, 30, 50, 100, 200],
      filterData: {},
      filterCount: 0,
      filterVisible: false,
      filterLoading: false,
      selectedData: [],
      selectedId: [],
      sortData: {prop:'', order:''}
    }
  },
  computed: {
    accum() {
      return (this.currentPage - 1) * this.pageSize;
    },
    getSortData() {
      if (!this.sortData.prop) {
        return null;
      }
      let order = '';
      if (this.sortData.order) {
        order = ' '+ this.sortData.order.replace('ending', '');
      }
      return this.sortData.prop + order;
    },
    queryData() {
      return Object.assign({}, {pageCurrent: this.currentPage, pageSize: this.pageSize}, this.searchData || {}, this.filterData || {});
    }
  },
  methods: {
    loadList() {
      if (this.loadedData) {
        return;
      }
      if (this.beforeLoad) {
        this.beforeLoad();
      }
      this.loadedData = true;
      this.doPost({
        url: this.listUrl,
        data: this.queryData || {},
        okcb: (json) => {
          if (this.listOkcb) {
            this.listOkcb(json);
          } else {
            this.list = json.list;
            this.totalRow = json.totalRow;
          }
          if (this.afterList) {
            this.afterList(json);
          }
          this.layoutTable();
        },
        cb: () => {
          this.$nextTick(() => {
            this.loadedData = false;
            this.filterLoading = false;
          })
        }
      });
    },
    doSearch() {
      this.currentPage = 1;
      this.loadList();
    },
    doFilter(data, count) {
      this.filterCount = count || 0;
      this.filterVisible = false;
      this.filterLoading = true;
      this.filterData = Object.assign({}, this.filterData, data);
      this.currentPage = 1;
      this.loadList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadList();
    },
    indexMethod(index) {
      return ((index + 1) + this.accum);
    },
    layoutTable() {
      this.$nextTick(() => {
        if (this.$refs.grid && (this.$refs.grid.$options._componentTag == 'el-table')) {
          this.$refs.grid.doLayout();
        }
      });
    }
  }
}
